import { get, post, postj } from '@/utils/request1';

export const City = (param) => get('orderw/c_city',param); // 用户信息
export const fCity = (param) => get('orderw/c_city_new',param); // 国际城市
export const cityInfo = (data) => post('orderw/getCityInfo',data); // 邮编识别州
export const serviceNameList = (data) => post('orderw/service_list',data); // 服务名称列表
export const serviceList = (param) => post('index/serviceList',param); // 获取服务列表
export const serviceListnew = (param) => get('index/serviceListnew',param); // 获取国际服务列表
export const checkAddress = (data) => postj('index/check_address',data); // 校验地址
export const provinceList = (param) => post('index/provinceList',param); // 根据国家获取州/省